import apiClient from 'application/core/data/apiClient'
import { PaymentProps } from 'application/core/domain/types/PaymentsType'
import { AxiosError } from 'axios'

export type QrSBP = {
  qrId: string // 1356...
  payload: string // htts://qr.nspk.ru/1356...
  qrStatus: string // STARTED
  renderedQr?: string
}

const createQrSBP = async (data: { mdOrder: string }) => {
  const response = await apiClient.post<QrSBP>('/api/payment/sbpPayment', data)

  return response.data
}

const createPayment = async (data: {
  amount: string | number
  open_order_id: number
  method: string
  return_url: string
}) => {
  const response = await apiClient.post('/api/payment', data)

  return response.data
}

export const sbpPay = async ({ data, onStart, onSuccess, onError }: PaymentProps) => {
  onStart()

  try {
    const response = await createPayment({
      amount: data.amount,
      open_order_id: data.order_id,
      method: 'alfa-card',
      return_url: data.returnUrl || 'moyservice://',
    })

    onSuccess('sbp', response)
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error(error, error.response)

      return onError(
        'error',
        error.response && error.response.data
          ? error.response.data.errorTypeName
            ? error.response.data.errorMessage
            : error.response.data.message
            ? error.response.data.message
            : 'Произошла ошибка при совершении оплаты'
          : 'Произошла ошибка при совершении оплаты',
      )
    }

    throw error
  }
}

export const createSBPPayment = async (
  mdOrder: string,
  withQRCode: boolean = false,
): Promise<[string, undefined] | [undefined, QrSBP]> => {
  try {
    const extra = withQRCode ? { qrWidth: '160', qrHeight: '160' } : {}
    const response = await createQrSBP({ mdOrder, ...extra })
    if ('errorMessage' in response && typeof response.errorMessage === 'string') {
      return [response.errorMessage, undefined]
    }

    if (!response.qrId) {
      return ['Произошла ошибка при совершении оплаты', undefined]
    }

    return [undefined, response]
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error(error, error.response)

      return ['Произошла ошибка при совершении оплаты', undefined]
    }

    throw error
  }
}
